import { render, staticRenderFns } from "./HeaderItem.vue?vue&type=template&id=1c08659f&"
import script from "./HeaderItem.vue?vue&type=script&lang=ts&"
export * from "./HeaderItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports